<unity-control-wrapper [control]="$control()" [description]="$description()" [displayName]="$displayName()" [showHint]="$showHint()">
  <kendo-textbox class="has-suffix" [formControl]="$control()" [clearButton]="$clearButton()" [type]="$type()" [title]="$control().value">
    @let suffix = $suffix();
    @if (suffix) {
      <ng-template kendoTextBoxSuffixTemplate>
        <kendo-textbox-separator />
        <div class="suffix">{{ suffix }}</div>
      </ng-template>
    }
  </kendo-textbox>
</unity-control-wrapper>
